import store from '@/state/store';
import router from '../router'; 
//import Swal from "sweetalert2";
import Vue from "vue";

export default function setup(axios) {

    axios.interceptors.request.use(function (config) {
        if(config?.withLoading){
            store.dispatch('loading/changeLoading',true);            
        }

        store.dispatch('notification/clear'); 
        
        // Add temporary token for 2FA requests if available
        const tempToken = store.state.auth.tempToken;
        if (tempToken && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${tempToken}`;
        }

        const currentToken = store.state.auth.currentToken;
        if (currentToken && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${currentToken}`;
        }
        
        return config;
    }, function (error) {
        store.dispatch('loading/changeLoading',false);
        return Promise.reject(error);
    });

    axios.interceptors.response.use(
        (response) => {
            store.dispatch('loading/changeLoading',false);
            return Promise.resolve(response);
        },
        async (error) => {
            store.dispatch('loading/changeLoading',false);
            
            const status = error?.response?.status;
            const data = error?.response?.data;
            
            switch (status) {
                case 401:
                {
                    // Clear user data
                    store.commit('auth/SET_CURRENT_USER', null);
                    store.commit('auth/SET_CURRENT_TOKEN', null);
                    store.commit('auth/CLEAR_TEMP_DATA');
                    
                    // Only redirect to login if we're not already on the login page
                    const currentRoute = router.currentRoute;
                    if (currentRoute.name !== 'login') {
                        // Preserve current route and query parameters for SSO context
                        router.push({ 
                            name: "login",
                            query: {
                                redirectFrom: currentRoute.fullPath,
                                ...currentRoute.query // Preserve SSO params (client_id, redirect_uri, etc.)
                            }
                        });
                    }
                }
                break;
                
                case 422:
                {
                    const validationErrors = data?.extra[0]?.errors;

                    let errorList = '';
                    Object.entries(validationErrors).forEach((obj) => {
                        if(obj[1][0]){
                            errorList += `<li>${(obj[1][0])}</li>`;
                        }
                    });

                    Vue.swal({
                        position: "top-end",
                        icon: "warning",
                        title: data?.errors[0]?.title,
                        showConfirmButton: false,
                        html:  `<ul>${errorList}</ul>`,
                        timer: 20000
                    });
                }
                break;
                
                case 429:
                {
                    // Rate limiting - specific handling for 2FA attempts
                    const message = data?.data?.message || data?.errors[0]?.title || 'Demasiados intentos';
                    const isTemp2FAError = data?.data?.temp_2fa_error || false;
                    
                    Vue.swal({
                        position: "top-end",
                        icon: "warning",
                        title: isTemp2FAError ? "Límite de intentos 2FA" : "Límite de intentos",
                        text: message,
                        showConfirmButton: false,
                        timer: 15000
                    });
                    
                    // Clear temporary token if 2FA rate limited
                    if (isTemp2FAError) {
                        store.commit('auth/CLEAR_TEMP_DATA');
                    }
                }
                break;
                
                case 403:
                {
                    // Handle 2FA specific forbidden errors
                    const is2FAError = data?.data?.requires_2fa_setup || data?.data?.requires_2fa;
                    
                    if (is2FAError) {
                        Vue.swal({
                            position: "top-end",
                            icon: "info",
                            title: "Autenticación requerida",
                            text: data?.errors[0]?.title || "Se requiere autenticación adicional",
                            showConfirmButton: false,
                            timer: 10000
                        });
                    } else {
                        Vue.swal({
                            position: "top-end",
                            icon: "error",
                            title: "Acceso denegado",
                            text: data?.errors[0]?.title || "No tienes permisos para realizar esta acción",
                            showConfirmButton: false,
                            timer: 10000
                        });
                    }
                }
                break;
                
                case 400:
                {
                    // Handle bad requests - often 2FA related
                    const errorTitle = data?.errors[0]?.title;
                    const is2FARelated = errorTitle && (
                        errorTitle.toLowerCase().includes('2fa') ||
                        errorTitle.toLowerCase().includes('two factor') ||
                        errorTitle.toLowerCase().includes('authenticator') ||
                        errorTitle.toLowerCase().includes('código')
                    );
                    
                    Vue.swal({
                        position: "top-end",
                        icon: is2FARelated ? "warning" : "error",
                        title: is2FARelated ? "Error de autenticación" : "Error en la solicitud",
                        text: errorTitle || "Solicitud inválida",
                        showConfirmButton: false,
                        timer: 10000
                    });
                }
                break;
                
                default:
                {
                    let errorData = {};
                    if (error.response && error.response.data instanceof Blob) {
                        try {
                            const errorText = await error.response.data.text();
                            const errorJson = JSON.parse(errorText);
                            errorData = errorJson;
                        } catch (parseError) {
                            console.error("Error al parsear el blob:", parseError);
                        }
                    } else {
                        errorData = data;
                    }

                    // Handle SSO specific errors
                    const isSSOError = errorData?.data?.sso_error || false;
                    const errorTitle = errorData?.errors[0]?.title || 'Ha ocurrido un error en el servidor';
                    
                    Vue.swal({
                        position: "top-end",
                        icon: isSSOError ? "info" : "warning",
                        title: isSSOError ? "Error SSO" : errorTitle,
                        text: isSSOError ? "Error en la autenticación SSO" : undefined,
                        showConfirmButton: false,
                        timer: 20000
                    });
                    
                    // Clear SSO params if SSO error
                    if (isSSOError) {
                        store.commit('auth/CLEAR_TEMP_DATA');
                    }
                }
                break;
            }

            return Promise.reject(error);
        }
    );
}